import React from 'react';
import { ListField, useFieldHelper } from 'framework/ui/field';
import { VIEW_SKILLS_PROPERTIES_VALUES } from '../constants';
import { Box, Typography } from '@mui/material';
import SkillStatusBadge from '../shared/SkillStatusBadge';
import { SkillPropertyAlias, SkillPropertyType, SkillType } from '../types';
import { Alert, AppIconLabel } from 'framework/ui/mui-builder';

const viewPropertyValue = (valuePropertry: string) => {
  // @ts-ignore
  return VIEW_SKILLS_PROPERTIES_VALUES[valuePropertry] || valuePropertry;
};

const PropertyList = ({
  properties,
  firstProp = false,
}: {
  properties: Dictionary<SkillPropertyType[]>;
  firstProp?: boolean;
}) => {
  return (
    <Box>
      {Object.entries(properties).map(([key, values]) => {
        const keyType = key as SkillPropertyAlias;
        return (
          <Box key={keyType}>
            {values.length === 1 ? (
              <>
                <Typography variant="body1">{viewPropertyValue(values[0].value)}</Typography>
                {values[0].properties && Object.keys(values[0].properties).length > 0 && (
                  <PropertyList properties={values[0].properties} />
                )}
              </>
            ) : (
              <>
                {values.map((item: any) => (
                  <Box key={item.id}>
                    <Typography variant="body1">{viewPropertyValue(item.value)}</Typography>
                    {item.properties && Object.keys(item.properties).length > 0 && (
                      <PropertyList properties={item.properties} />
                    )}
                  </Box>
                ))}
              </>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

const SkillsField = (props: any) => {
  const { getValue } = useFieldHelper<SkillType>(props);
  const data = getValue();

  return (
    <Box sx={{ mb: '10px' }}>
      <Box display="flex" flexDirection="column">
        <Box display="flex" justifyContent="space-between" mb="5px">
          <Typography variant="subtitle1">{data.skillName}</Typography>
          <SkillStatusBadge status={data.status} />
        </Box>
        <Box>
          {data.properties && Object.keys(data.properties).length > 0 && (
            <Box>
              <PropertyList properties={data.properties} firstProp />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const SkillsView = () => {
  const { getValue } = useFieldHelper<SkillType[]>({ source: 'skills' });
  const skills = getValue();

  if (!Array.isArray(skills) || skills.length === 0) {
    return <Alert color="info">Skills not found</Alert>;
  }

  return (
    <Box display="flex" alignItems="flex-start">
      <AppIconLabel icon="certificate" tooltipTitle="Skills" />
      <Box width="100%">
        <ListField source="skills" label="">
          <SkillsField />
        </ListField>
      </Box>
    </Box>
  );
};

export default SkillsView;
